import { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../../../api/AxiosApi";

function BusinessGroupListDelete({ show, handleClose, userId, handleDeleteSuccess,userData }) {


    const { PrimaryColor } = useContext(AppThemeContext);
    const User_ID = localStorage.getItem("business_LOGIN_ID");
 

    const handleDelete = async (e) => {
        e.preventDefault();
    
        if (!userData.Group_id) {
            console.error("Group ID is missing. Cannot delete.");
            return;
        }
    
        try {
            const queryParams = new URLSearchParams({
                Group_Name: userData.CompanyName,
                Address: userData. Address,
                Mail_ID: userData.Email,
                Password: userData.Password,
                SKey: "XYZ"
            }).toString();
            
    
            const formBody = new URLSearchParams({
                USER_ID: User_ID,
                Group_ID: String(userData.Group_id),
                TYPE_ID: "D"
            }).toString();
    
            const finalUrl = `${BaseUrl}CMN_10_Update/iGroup?${queryParams}`;
           
    
            const response = await fetch(finalUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formBody,
            });
    
            if (!response.ok) {
                throw new Error("Failed to delete user.");
            }
    
            const result = await response.json();  // Directly parse as JSON
            console.log("API Response Data:", result);
    
            if (result?.success || result?.status === "success") {
                handleDeleteSuccess(userData.Group_id);  // Notify parent component
                handleClose();  // Close modal
            } else {
                console.error("Deletion failed:", result);
            }
        } catch (error) {
            console.error("Error deleting user:", error);
        }
    };
    

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to delete this user?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose} style={{ backgroundColor: PrimaryColor }}>
                    Cancel
                </Button>
                <Button onClick={handleDelete} style={{ backgroundColor: "red", color: "#fff" }}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default BusinessGroupListDelete;
